
<template>

  <main class="heat-outer">
    <header class="heat-header">
      <div v-for="node in headerNodes" :class="activeNode === node.val && bubble ? 'heat-node active-heat-node' : 'heat-node'" @click="setActiveNode(node)" :style="{'cursor': bubble ? 'pointer' : 'default'}">
        <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${node.img}.png`" />
        <h5 v-if="activeNode === node.val && bubble" v-html="clauses[node.label]">{{clauses[node.label]}}</h5>
        <div class="inactive-heat" v-if="!bubble"></div>
      </div>
      <div class="heat-node">
        <div class="heat-node half-heat" @click="$store.dispatch('setFloor', {breakpoint: $screen.breakpoint, index: floor.info.index, name: floor.info.name, navNew: true})">
          <h5 style="width:50%;font-size:1.3em;">+</h5>
          <h6>{{clauses.add}}</h6>
        </div>
        <div class="heat-node half-heat" @click="togBub()">
          <div class="half-heat-img">
            <img :src="`https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${bubble ? 'multicard' : 'bubz'}.png`" />
          </div>
          <h6>{{bubble ? clauses.cards : 'Bubble'}}</h6>
        </div>
      </div>
    </header>
    <div class="heat-body">
      <bubble-component v-if="bubble" :rooms="floor.rooms" :rdg="activeNode"></bubble-component>
      <card-component v-else v-for="room in sortByParent()" :room="room" v-on:remount="$forceUpdate()" style="margin:7px;height:575px;"></card-component>
    </div>
  </main>

</template>

<script>

import { mapState } from 'vuex';

import Lang from '@/lib/langTemplates/FloorTemplate';

import Bubble from './Bubble';
import Card from '@/components/card/Frame';

export default {

  data(){
    return {
      headerNodes: [
        {
          val: 'days',
          img: 'filterOfficial',
          label: 'filter'
        },
        {
          val: 'ttp',
          img: 'temp',
          label: 'temp'
        },
        {
          val: 'hhm',
          img: 'hum',
          label: 'hum'
        },
        {
          val: 'iaq',
          img: 'iaq',
          label: 'iaq'
        },
        {
          val: 'co2',
          img: 'eCO2',
          label: 'co2'
        },
        {
          val: 'voc',
          img: 'nuevoVOC',
          label: 'voc'
        }
      ],
      activeNode: 'ttp'
    }
  },

  components: {
    'bubble-component': Bubble,
    'card-component': Card
  },

  computed: {
    floor(){
      return this.$store.getters.getActiveFloor();
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    },
    bubble(){
      return this.$store.state.bubbles;
    }
  },

  methods: {

    setActiveNode(node){
      if (this.bubble) this.activeNode = node.val
    },

    togBub(){
      this.$store.dispatch('switchBubbles');
      this.$store.dispatch('destroyHover');
    },

    sortByParent(){
      let rooms = this.floor.rooms;
      if (rooms.some(r => r.parent)) {
        const parents = rooms.filter(r => typeof r.parent !== 'string');
        rooms = rooms.filter(r => parents.includes(r)).concat(rooms.filter(r => !parents.includes(r)));
      }
      return rooms;
    }

  },

  mounted(){
    if (Math.round(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    } else {
      this.$store.dispatch('setNav', ['org', 'bldg', 'floor']);
      this.$store.dispatch('componentHeader', {
        type: 'floor',
        title: this.floor.info.name,
        lgText: this.floor.rooms.length,
        smText: `Area${this.floor.rooms.length === 1 ? '' : 's'}<br />Monitored`,
        alerts: this.floor.overallAlerts
      });
    }
    this.$store.dispatch('clearIdsAndIndexes', 'floor');

  },

  watch: {
    '$screen.breakpoint': function(newData, oldData){
      if (newData === 'sm') this.$router.push({path: `/floor/${this.floor.info.index}`});
    }
  }

}

</script>

<style>

.heat-outer {
  width: 76vw;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid rgb(0, 153, 191);
  margin-top: 10px;
  border-radius: 5px;
}

.heat-header {
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #325468;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.heat-node {
  width: 13.5%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(0, 153, 191);
  background-color: #0f1621;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.heat-node img {
  height: 40%;
}

.heat-node h5 {
  margin: 8px;
  text-align: center;
  animation: slideup .2s linear forwards;
}

.active-heat-node {
  background-color: rgb(0, 153, 191);
}

@keyframes slideup {
  0% {
    margin-top: 200px;
  }
  100% {
    margin-top: 8px;
  }
}

.heat-body {
  width: 100%;
  height: 100%;
  /* padding: 3px; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #1A2839;
}

.half-heat {
  height: 44%;
  width: 95%;
  margin: 1%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid lightgray;
}

.half-heat-img {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.half-heat-img img {
  height: 80%;
}

.half-heat h5 {
  width: 0px;
  margin: 0px;
  animation: none;
}

.inactive-heat {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #0f1621;
  opacity: .85;
}

</style>



// WEBPACK FOOTER //
// src/components/floor/Heatmap.vue